import { Menu, MenuItem } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import moreSvg from 'assets/img/more-horizontal.svg';
import { tabs } from 'constants/checlistTableTabs';
import { HW, ICL } from 'shared/types';

const menuItemStyles = {
  paddingX: '8px',
  paddingY: '4px',
  borderRadius: '5px',

  '&:hover': {
    backgroundColor: '#DCF0FF !important',
  },
};

interface Props {
  icl: ICL | HW;
  tab: string;
  isLoading: boolean;
  handleOpenSendPopup: (id: string) => void;
  openSendToStudentsModal: (icl: ICL) => void;
  handleArchivePopup: (icl: ICL, isActive: boolean) => void;
  hw?: boolean;
}

export const DropdownOfTableButtons = ({
  icl,
  tab,
  isLoading,
  handleOpenSendPopup,
  openSendToStudentsModal,
  handleArchivePopup,
  hw,
}: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id, isConsideration, isTemplate, isActive } = icl;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Tooltip
        title={t('options')}
        componentsProps={{
          popper: {
            sx: {
              ['& .MuiTooltip-arrow']: {
                color: '#9CDFFC',
              },
              ['& .MuiTooltip-tooltip']: {
                backgroundColor: '#9CDFFC',
                color: '#000000',
                fontSize: '14px',
                padding: '14px',
                borderRadius: '8px',
              },
            },
          },
        }}
        arrow
      >
        <button
          id="basic-button"
          aria-controls={isOpen ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={isOpen ? 'true' : undefined}
          onClick={handleClick}
          className={`btn more small h-[40px] w-[40px] rounded-[8px] !p-[6px] ${isOpen && '!bg-[#9CDFFC]'}`}
        >
          <img src={moreSvg} alt="more buttons" />
        </button>
      </Tooltip>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: -8,
          horizontal: 'right',
        }}
        sx={{
          '& .MuiPaper-root': {
            padding: 0,
          },
          '& .MuiList-root': {
            paddingX: '8px',
            paddingY: '12px',
            borderRadius: '10px',
            borderWidth: '2px',
            borderColor: '#52C7FA',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          },
        }}
      >
        {!isConsideration && tab !== tabs.archived && (
          <MenuItem
            onClick={() => {
              handleOpenSendPopup(id);
              handleClose();
            }}
            sx={menuItemStyles}
          >
            <button disabled={isLoading}>
              <p className="!mb-0 text-left text-base font-bold text-charleston-green">{t('Send For Consideration')}</p>
            </button>
          </MenuItem>
        )}

        {!isTemplate && (
          <>
            {tab !== tabs.archived && (
              <MenuItem
                onClick={() => {
                  openSendToStudentsModal(icl);
                  handleClose();
                }}
                sx={menuItemStyles}
              >
                <button>
                  <p className="!mb-0 text-left text-base font-bold text-charleston-green">{t('Send to students')}</p>
                </button>
              </MenuItem>
            )}

            <MenuItem
              onClick={() => {
                handleArchivePopup(icl, isActive);
                handleClose();
              }}
              sx={menuItemStyles}
            >
              <button>
                <p className="!mb-0 text-left text-base font-bold text-charleston-green">
                  {isActive ? t('Archived') : t('activateButton')}
                </p>
              </button>
            </MenuItem>

            {tab !== tabs.archived && (
              <MenuItem
                onClick={() => {
                  if (hw) {
                    navigate('/hw-teacher', { state: { hwId: id } });
                  } else {
                    navigate('/checklist-teacher-new', { state: { checkListId: id } });
                  }

                  handleClose();
                }}
                sx={menuItemStyles}
              >
                <button>
                  <p className="!mb-0 text-left text-base font-bold text-charleston-green">{t('Check')}</p>
                </button>
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </>
  );
};
